import { useEffect, useState } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  IFaqs,
  fetchFaqsApiCall,
  getFaqsFields,
  handleActiveInactiveFaqs,
  handleDeleteFaqs,
} from "./FaqsViewController";
import usePagination from "../../hooks/UsePaginationHook";
import { PER_PAGE_ROWS } from "../../config/AppConfig";
import { IPagination } from "../../data/AppInterface";
import { editIcon, eyeIcon, restoreIcon } from "../../assets/icons/SvgIconList";
import { ORDER_BY } from "../../utils/AppConstants";
import AdvanceSearch from "../../components/page-layouts/AdvanceSearch";
import ICTable from "../../core-component/ICTable";
import FaqsForm from "./FaqsForm";
import ICSweetAlertModal from "../../core-component/ICSweetAlertModal";

const FaqsView = () => {
  const { t } = UseTranslationHook();
  let timer: NodeJS.Timeout;
  const [isLoading, setIsLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [readOnlyForm, setReadOnlyForm] = useState(false);
  const [enterpriseSearch, setEnterpriseSearch] = useState("");
  const [faqsList, setFaqsList] = useState<IFaqs[]>([]);
  const [faqsToEdit, setFaqsToEdit] = useState<IFaqs>();
  const [deleteAll, setDeleteAll] = useState(false);
  const { pagination, setPagination } = usePagination({
    pagination: {
      perPageRows: Number(PER_PAGE_ROWS),
      currentPage: 1,
      sortBy: "question",
      orderBy: "ASC",
    },
  });
  useEffect(() => {
    fetchFaqs(pagination);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [enterpriseSearch, deleteAll]);

  const fetchFaqs = (payloadPagination: IPagination) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(async () => {
      setIsLoading(true);
      await fetchFaqsApiCall(setFaqsList, setPagination, payloadPagination, {
        enterpriseSearch,
        deleteAll,
      });
      setIsLoading(false);
    }, 500);
  };

  const handleFaqsStatus = async (values: IFaqs) => {
    var isStatusChange = await handleActiveInactiveFaqs(
      values.id,
      values.is_active === "1" ? "0" : "1"
    );
    if (isStatusChange) {
      const updatedFaqsList = faqsList.map((faqs) => {
        if (faqs.id === values.id) {
          return {
            ...faqs,
            is_active: values.is_active === "1" ? "0" : "1",
          };
        }
        return faqs;
      });

      setFaqsList(updatedFaqsList);
    }
  };
  const handleCloseForm = (status: boolean) => {
    setShowForm(false);
    setReadOnlyForm(false);
    if (faqsToEdit) {
      setFaqsToEdit(undefined);
    } else {
      setEnterpriseSearch("");
    }
    if (status) {
      fetchFaqs(pagination);
    }
  };

  const handleDeleteCfm = async (id: number) => {
    const data = await handleDeleteFaqs(id, t);
    if (data) {
      fetchFaqs(pagination);
    }
  };
  const customActionView = (item: IFaqs) => {
    return (
      <div>
        {item.deleted === "1" ? (
          <div className="flex item-center justify-center ml-2">
            <div
              className="mr-2 action-view"
              title={t("restore")}
              onClick={() => handleDeleteCfm(item.id)}
            >
              {restoreIcon}
            </div>
          </div>
        ) : (
          <div className="flex item-center justify-center ml-2">
            <div
              className="mr-2 action-view"
              title={t("view_tooltip_icon")}
              onClick={() => {
                setShowForm(true);
                setFaqsToEdit(item);
                setReadOnlyForm(true);
              }}
            >
              {eyeIcon}
            </div>
            <div
              className="mr-2 action-view "
              title={t("edit_tooltip_icon")}
              onClick={() => {
                setShowForm(true);
                setFaqsToEdit(item);
              }}
            >
              {editIcon}
            </div>
            <div className="action-view " title={t("delete_tooltip_icon")}>
              <ICSweetAlertModal onConfirm={handleDeleteCfm} itemId={item.id} />
            </div>
          </div>
        )}
      </div>
    );
  };
  const allFaqsList = faqsList.map((val) => ({
    ...val,
    IsDeleted: val.deleted === "1" ? true : false,
  }));
  return (
    <div className="w-full overflow-auto scrollbar-remove">
      <AdvanceSearch
        handleOnClickAdd={() => setShowForm(true)}
        handleSearchChange={(text) => {
          setEnterpriseSearch(text);
        }}
        searchText={enterpriseSearch}
        handleDeleteCheckBox={(ans) => {
          setDeleteAll(ans);
        }}
        filterCheckBox={deleteAll}
        refreshTable={() => fetchFaqs(pagination)}
      />
      <ICTable<IFaqs>
        isLoading={isLoading}
        totalFlex="grid grid-cols-16"
        fields={getFaqsFields(handleFaqsStatus, customActionView, t)}
        data={allFaqsList}
        pagination={pagination}
        handleChangePerPageRows={(perPageRow) =>
          fetchFaqs({
            ...pagination,
            perPageRows: perPageRow,
            currentPage: 1,
          })
        }
        handleChangePage={(page) =>
          fetchFaqs({ ...pagination, currentPage: page })
        }
        handleSort={(field) =>
          fetchFaqs({
            ...pagination,
            sortBy: field.key,
            orderBy:
              pagination.orderBy === ORDER_BY.desc
                ? ORDER_BY.asc
                : ORDER_BY.desc,
          })
        }
      />
      {showForm && (
        <FaqsForm
          handleClose={handleCloseForm}
          faqsToEdit={faqsToEdit}
          readOnly={readOnlyForm}
        />
      )}
    </div>
  );
};
export default FaqsView;
